import HomeClient from 'flow/api-clients/home-client';

export const getRingtoneUrl = (ringtoneEntityKey) => {
    return `${HomeClient.getActiveEndpoint()}/ringtones/${ringtoneEntityKey}/audio`;
};

export const isRingtoneDTO = (ringtoneDTO) => {
    return (
        !!ringtoneDTO &&
        /ringtone-[0-9]+/.test(ringtoneDTO.get('key')) &&
        typeof ringtoneDTO.get('name') === 'string'
    );
};
